var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({tag:"component",staticClass:"c-btn truncate",class:[
    {
      small: _vm.small,
      large: _vm.large,
      block: _vm.block,
      outline: _vm.outline,
      loading: _vm.loading,
      [_vm.kind]: true,
      'c-btn-icon': _vm.icon && !_vm.$slots.default,
      group: true,

      // Base
      'tw-inline-block tw-px-4 tw-py-2 tw-rounded-md': true,
      'tw-text-sm tw-leading-5 tw-no-underline hover:tw-no-underline': true,
      'tw-border tw-border-solid': true,
      'disabled:tw-opacity-50 disabled:tw-cursor-default': true,

      // Variants
      'tw-text-white': _vm.kind === 'primary' && !_vm.outline,
      'hover:tw-text-white': _vm.kind === 'primary' && !_vm.outline,
      'active:tw-text-white': _vm.kind === 'primary' && !_vm.outline,

      // Default
      'tw-text-black': _vm.kind === 'default',

      // Primary
      'tw-border-blue-600': _vm.kind === 'primary',
      'tw-bg-blue-600': _vm.kind === 'primary' && !_vm.outline,
      'hover:tw-bg-blue-700 hover:tw-border-blue-700 active:hover:tw-bg-blue-600 active:hover:tw-border-blue-600':
        _vm.kind === 'primary' && !_vm.outline,
      'active:tw-bg-blue-800 active:tw-border-blue-800':
        _vm.kind === 'primary' && !_vm.outline,
      'disabled:tw-bg-blue-600 disabled:tw-border-blue-600':
        _vm.kind === 'primary' && !_vm.outline,
      'tw-text-blue-600 hover:tw-bg-blue-600 active:tw-bg-blue-800':
        _vm.kind === 'primary' && _vm.outline,

      // Secondary
      'tw-border-gray-200 tw-text-blue-600': _vm.kind === 'secondary',
      'hover:tw-cursor-pointer hover:tw-bg-gray-50 hover:tw-border-gray-200':
        _vm.kind === 'secondary',
      'active:tw-cursor-pointer active:tw-bg-gray-100 active:tw-border-gray-300':
        _vm.kind === 'secondary',
      'tw-text-blue-600 tw-bg-white tw-shadow-gray-600/7':
        _vm.kind === 'secondary' && !_vm.outline,

      // Danger
      'tw-text-red-600 tw-bg-white tw-border-gray-200': _vm.kind === 'danger',
      'focus:tw-border-red-400 focus:tw-ring-red-500/30': _vm.kind === 'danger',
      'hover:tw-bg-red-500 hover:tw-text-white hover:tw-border-red-600':
        _vm.kind === 'danger',
      'active:tw-bg-red-600': _vm.kind === 'danger',
    },
  ],attrs:{"to":_vm.to,"href":_vm.href,"target":_vm.target,"type":_vm.computedType},on:{"click":function($event){return _vm.$emit('click')}}},'component',_vm.additionalAttributes,false),[(_vm.loading)?[_c('c-spinner',{attrs:{"animationClass":`border-${_vm.animationColor} group-hover:border-${_vm.animationColorHover}`}})]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"c-btn-content"},[(_vm.icon && _vm.icon.length > 0)?_c('c-icon',{staticClass:"tw-mr-1",attrs:{"icon":_vm.icon,"size":"3"}}):_vm._e(),_vm._v(" "),_vm._t("default"),_vm._v(" "),(_vm.trailingIcon && _vm.trailingIcon.length > 0)?_c('c-icon',{staticClass:"tw-ml-1",attrs:{"icon":_vm.trailingIcon,"size":"3"}}):_vm._e()],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }